// actions
import audienceId from '@/store/actions/audienceId'
import slideOptions from '@/store/actions/slideOptions'
import slides from '@/store/actions/slides'
import presentation from '@/store/actions/presentation'

export default {
  ...audienceId,
  ...slideOptions,
  ...slides,
  ...presentation,
  setLang: (context, payload) => {
    context.commit('setLang', payload)
  },

  // Set presentation
  setSlide: (context, payload) => {
    context.commit('setSlide', payload)
  },

  // Update Presentation
  updateSlide: (context, payload) => {
    context.commit('updateSlide', payload)
  },

  // Update Presentation
  setConnectionError: (context, payload) => {
    context.commit('setConnectionError', payload)
  },
}
